import React from 'react';
import './ResizeHandle.css';

export interface ResizeHandleProps {
  columnId: string;
  currentWidthPx: number;
  onResizeStart: (columnId: string, startX: number, startWidthPx: number) => void;
  disabled?: boolean;
}

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  columnId,
  currentWidthPx,
  onResizeStart,
  disabled = false,
}) => {
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    onResizeStart(columnId, e.clientX, currentWidthPx);
  };

  return (
    <span
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize column"
      onMouseDown={handleMouseDown}
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 6,
        height: '100%',
        cursor: disabled ? 'default' : 'col-resize',
        userSelect: 'none',
        zIndex: 10,
      }}
      className="resize-handle"
    />
  );
};
